import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Driver, DriverSimple } from '../../model/driver';
import { IShift } from '../../model/shiftTable';
import { DriverserviceService } from '../../lib/serviceLib/driverservice.service';
import { FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { debug } from 'util';

@Component({
  selector: 'app-add-shift',
  templateUrl: './add-shift.component.html',
  styleUrls: ['./add-shift.component.css']
})
export class AddShiftComponent implements OnInit {
  fromID: number
  fromInfo: Driver
  selectedShift: IShift
  replacedDateShift: Date

  fromShiftList: IShift[] = [];
  dateMain = new FormControl(new Date());
  messageInput = new FormControl('');
  penalltyCode = '';
  fromDate = -1;
  typeReplace = 1;
  constructor(
    public serviceService: DriverserviceService,
    private matSnackbar: MatSnackBar,
    //private dialog: MatDialog,
    //public dialogRef: MatDialogRef<AddShiftComponent>,
    //@Inject(MAT_DIALOG_DATA) public data: {
    //  fromID: number,
    //  fromInfo: Driver,
    //  selectedShift: IShift,
    //  fromShift: IShift[]
    //}
  ) {
    this.dateMain.valueChanges.subscribe((selectedDate) => {
      this.onSelectedMainDateChange(selectedDate);
    });
    //this.fromID = data.fromID;
    //this.fromInfo = data.fromInfo;
    //this.selectedShift = data.selectedShift;
    ////this.shiftName = this.selectedShift.getShiftName(data.fromID);
    //this.fromShiftList = data.fromShift;
    //this.fromDate = this.selectedShift.id ?? -1;
    //this.updateShiftName(this.selectedShift.id);
    //console.log(data);

  }
  shiftName: string;
  replaceDriver: DriverSimple;
  onSelectedMainDateChange(selectedDate: Date) {
    this.replacedDateShift = selectedDate;
    this.serviceService.getShiftByDate(selectedDate, this.shiftName).subscribe((res: DriverSimple) => {
      this.replaceDriver = res;
    });

    console.log('تاریخ انتخاب شده:', selectedDate);
  }

  loadInit() {
    if (!this.fromShiftList) {
      this.serviceService.getShiftTable(this.fromID).subscribe(res => {
        this.fromShiftList = res;
      });
    }
  }

  ngOnInit(): void {

  }

  selectPenalltyCode(shiftId: number): void {
    console.log('updateShiftName ' + shiftId);
    this.selectedShift = this.fromShiftList.find(shift => shift.id == shiftId);

    console.log('selectedShift ', this.selectedShift);
    console.log('this.fromShiftList ', this.fromShiftList);
    if (this.selectedShift.shiftAsrDriverID == this.fromID)
      this.shiftName = 'عصر';
    else if (this.selectedShift.shiftNightDriverID == this.fromID)
      this.shiftName = 'شب';
    this.updateTtypeReplace(1);
  }
  minDate = new Date((new Date()).setMonth(new Date().getMonth() - 1));
  maxDate = new Date((new Date()).setMonth(new Date().getMonth() + 1));
  updateTtypeReplace(typeID: number): void {
    if (typeID == 1) {
      //if (this.selectedShift)
      //  this.minDate = this.selectedShift.date;
      //else
      this.minDate = new Date();
    }
    else {
      this.minDate = new Date((new Date()).setMonth(new Date().getMonth() - 1));
    }
  

}

saveReplace() {
  //this.fromID
  //this.selectedShift
  //this.replaceDriver
  //this.replacedDateShift
  if (this.typeReplace == 1) {

    debugger;
    if (this.replacedDateShift.toDateString() < (new Date()).toDateString()) {
      this.matSnackbar.open('با روزهای گذشته نمی توان جا به جا نمود', null, { duration: 5000 });

      return;
    }
  }
  this.serviceService.saveReplace(this.fromID, this.replaceDriver.id, this.selectedShift.date, this.replacedDateShift, this.shiftName, this.messageInput.value, this.typeReplace).subscribe(res => {
    console.log('this.serviceService.saveReplace' + res);
  });

  this.matSnackbar.open('درخواست جا به جایی ارسال شد و در صورت تایید به اطلاع شما خواهد رسید', null, { duration: 5000 });
  //this.dialogRef.close();
}
}
